import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { restPath,  apiKey } from '../../app/constants';
import { map } from 'rxjs/operators';
import { LoginProvider } from '../login/login';
import { DomProvider } from '../dom/dom';
import { jsonpCallbackContext } from '@angular/common/http/src/module';

/* tslint:disable:no-any */
@Injectable()
export class RestHttpInterceptor implements HttpInterceptor {
  private readonly authUrl;

  constructor(
    public http: HttpClient,
    private login: LoginProvider,
    private dom: DomProvider
  ) {
    let baseUrl = localStorage.getItem('base_url');
    // if (!dom.isLocalhost()) {
    //   baseUrl += 'autoflex/'
    // }
    // baseUrl += `${restPath}`;
    // console.log('Path: ' + baseUrl)
    this.authUrl = `${baseUrl}authenticate?api_key=${apiKey}`;
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let request$;

    // No token needed to do authentication
    if (req.url === this.authUrl) {
      // Authenticate and fetch token
      request$ = next.handle(req).catch((error, caught) => {
        console.error('Authentication error', error);
        return Observable.throw(error);
      });

      // Authenticate, then do request
    } else {
      request$ = this.login.data$.switchMap(({ token }) =>
        this.getNext$(req, next, token)
      );
    }
    // console.log(request$)
    return request$;
  }

  private getNext$(req: HttpRequest<any>, next: HttpHandler, token: string, api_url?: string) {
    let reqToken: string = token;
    if (!localStorage.getItem('token')) {
      localStorage.setItem('token', token);
      reqToken = localStorage.getItem('token');
    }
    const authReq = req.clone({
      headers: req.headers.set('token', reqToken)
    });
    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => {
          return event;
      }));
    // return next.handle(authReq)
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-interceptor/http-interceptor.ts